import { observer } from "mobx-react-lite";
import styles from "./linkButton.module.scss";
import { Button } from "@fluentui/react-northstar";
import React from "react";
import { RegularText } from "../regularText/RegularText";

export interface LinkButtonProps {
    text: string;
    onClick: () => void;
}

export const LinkButton: React.FC<LinkButtonProps> = observer((props) => {
    return (
        <Button className={styles.button} text content={<RegularText content={props.text} />} onClick={props.onClick} />
    );
});

export const linkButtonStyles = styles.button;
